module.exports = __webpack_public_path__ + "static/media/Floorplay_Low_Impact_Dance_Fitness_2.05a3c6f4.webp";